import { EmptyState } from 'ui/emptyState';
import { NotProvisionedEmptyState } from 'ui/illustrations';
import { Link } from 'ui/links';
import {
  IntelligentInsightsBackground,
  Wrapper,
  DescriptionWrapper,
} from 'modules/intelligentInsights/IntelligentInsights.styles';

export const IntelligentInsightsNotEnabled = ({
  featureName,
  testId,
}: { featureName: string; testId: string }) => (
  <IntelligentInsightsBackground data-test={testId}>
    <Wrapper>
      <EmptyState
        Illustration={NotProvisionedEmptyState}
        title={`${featureName} not enabled for this project`}
        subtitle={
          <DescriptionWrapper>
            <span>Contact your CSM if you'd like to enable this feature.</span>
            <span>
              {`Learn more by visiting our `}
              <Link size="body1" target="_blank" href={'https://support.iterable.com/'}>
                Knowledge Center
              </Link>
            </span>
          </DescriptionWrapper>
        }
      />
    </Wrapper>
  </IntelligentInsightsBackground>
);
